import { ConstructionIcon } from 'lucide-react';
import useApiManager from 'networking/ApiManager';
import React, { useEffect, useMemo, useState } from 'react';
import { warn } from 'react-bootstrap-typeahead/types/utils';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setReduxRegimeData } from 'redux/Slices';
import { add, editIconY, uploaded } from 'res/images';
import { CommonAlert, Loader, Pagination } from 'whealth-core-web/components';
import CommonToolTip from 'whealth-core-web/components/CommonToolTip';
import { dateFormat, profileImage, splitArrData, teamRoles, timeFormat } from 'whealth-core-web/components/Helper';

function RenderQuestionTab(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [behaviourQuetionData, setbehaviourQuetionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('alert-success');
  const [callRecordingData, setCallRecordingData] = useState([]);
  const [showCallRecordingModal, setShowCallRecordingModal] = useState(false);
  const [callRecordingLoading, setCallRecordingLoading] = useState(false);
  const [callRecordingCurrentPage, setCallRecordingCurrentPage] = useState(1);
  const [callRecordingTotalPages, setCallRecordingTotalPages] = useState(1);
  const [callRecordingTotalCount, setCallRecordingTotalCount] = useState(0);
  const [callRecordingPageSize, setCallRecordingPageSize] = useState(20);
  const ApiClient = useApiManager();
  const { id, pdf } = useParams();
  const { newQuestions, userData } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    getListData();
  }, [currentPage]);

  useEffect(() => {
    if (showCallRecordingModal) {
      getCallRecordingAnalysis(callRecordingCurrentPage);
    }
  }, [showCallRecordingModal, callRecordingCurrentPage]);

  const getListData = () => {
    setIsLoading(true);
    let params = { page: currentPage };
    ApiClient.behaviourQuestionList(id, params)
      .then((res) => {
        setIsLoading(false);
        setTotalPages(res.headers['total-pages']);
        setbehaviourQuetionData(res.data);
        dispatch(setReduxRegimeData(res.data));
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getCallRecordingAnalysis = (page = 1) => {
    setCallRecordingLoading(true);
    ApiClient.getCallRecordingAnalysis(id, { page })
      .then((res) => {
        setCallRecordingData(res.data?.results || []);
        setCallRecordingTotalPages(res.data?.total_pages || 1);
        setCallRecordingTotalCount(res.data?.total_count || 0);
        setCallRecordingCurrentPage(res.data?.current_page || page);
        setCallRecordingPageSize(res.data?.page_size || 20);
      })
      .catch(() => {
        setCallRecordingData([]);
        setCallRecordingTotalPages(1);
        setCallRecordingTotalCount(0);
      })
      .finally(() => setCallRecordingLoading(false));
  };

  const fetchCallRecordingAnalysis = () => {
    if (showCallRecordingModal) {
      setShowCallRecordingModal(false);
      return;
    }
    setCallRecordingData([]);
    setCallRecordingCurrentPage(1);
    setCallRecordingTotalPages(1);
    setCallRecordingTotalCount(0);
    setShowCallRecordingModal(true);
  };

  const getPdf = (item) => {
    setIsLoading(true);
    const date = new Date();
    ApiClient.questionPdfDownload(id, item.id)
      .then((res) => {
        setIsLoading(false);
        let blobURL = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        let iframe = document.createElement('iframe'); //load content in an iframe to print later
        document.body.appendChild(iframe);
        iframe.style.display = 'none';
        iframe.src = blobURL;
        iframe.onload = function () {
          setTimeout(function () {
            iframe.focus();
            iframe.contentWindow.print();
          }, 1);
        };
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const statusPublish = (item) => {
    setIsLoading(true);
    ApiClient.statusQuestionPublish(id, item.id)
      .then((res) => {
        setIsLoading(false);
        getListData();
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const renderAnswer = (item, key) => {
    if (item.behaviour_question.type == 'multi_select') {
      let ansArr = splitArrData(item[key], '|');
      return (
        <ul>
          {ansArr.map((item, index) => {
            return <li key={index}>{item}</li>;
          })}
        </ul>
      );
    }
    if (item.behaviour_question.type == 'date') {
      const input = item[key];
      let [year, month, day] = typeof input == 'string' ? input.split('-') : '';
      return item[key] ? `${day}/${month}/${year}` : '';
    }
    return item[key];
  };

  const duplicateQuestions = (question_id) => {
    setIsLoading(true);
    ApiClient.duplicateRegimeQuestions(id, question_id)
      .then((res) => {
        getListData();
        setIsLoading(false);
        setIsShowAlert('Conversion Log Duplicated Successfully.');
        setAlertType('alert-success');
        // navigate(`/patient/${id}/questions/${res.data.id}/edit`);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const behaviouQuestionDelete = (questionId) => {
    setIsLoading(true);
    // seterror({});
    ApiClient.deleteQuestions(id, questionId)
      .then((res) => {
        setIsLoading(false);
        getListData();
        console.log(res);
        setIsShowAlert('Conversion Log deleted successfully.');
        setAlertType('alert-success');
      })
      .catch((err) => {
        // setIsLoading(false);
        if (err.response.status == 500) {
          setIsShowAlert('Internal server error');
        } else {
          setIsShowAlert(err.response.data.message);
        }
        setAlertType('alert-danger');
        setIsShowAlert(err.response.data.detail || err.response.data.message);
        console.log(err);
      });
  };

  const renderQuestionlist = (item, index) => {
    return (
      <div className='cardDataBorder w-100'>
        <div className='d-flex justify-content-between'>
          <div className='headingMilestone d-flex justify-content-between'>
            <div>
              <b>Assigned On &nbsp; &nbsp;</b>
              {dateFormat(item.created_at)} · {timeFormat(item.created_at)}
            </div>
            {/* <div className='d-block  ms-2 '>
              <span className={`badge bg-info  capitalize ${item.status}`}>{item.status}</span>
            </div> */}
          </div>

          <div
            className='memberShipDetails'
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {/* {(item.status == 'draft' && !['doctor', 'ee', 'ee_manager'].includes(userData?.role)) && (
              <div
                className='mb-1 ms-2 pointer'
                onClick={() => {
                  let windoConfirm = window.confirm('Are you sure you want to delete this conversion log?');
                  if (windoConfirm) {
                    behaviouQuestionDelete(item.id);
                  }
                }}
              >
                <div className='pt-1'>
                  <CommonToolTip
                    placement={'top'}
                    item={<span class='material-icons-outlined'>delete_outline</span>}
                    showValue={'Delete'}
                  />
                </div>
              </div>
            )} */}

            {/* {!['doctor', 'ee', 'ee_manager'].includes(userData?.role) && (
              <div
                className='mb-1 ms-2 pointer'
                onClick={() => {
                  duplicateQuestions(item.id);
                }}
              >
                <CommonToolTip
                  placement={'top'}
                  item={
                    <div className='pt-1'>
                      <span className='material-icons-outlined' style={{ color: '#757575' }}>
                        content_copy
                      </span>
                    </div>
                  }
                  showValue={'Duplicate'}
                />
              </div>
            )} */}

            <>
              {item.status == 'published' && (
                <div className='mb-2 pointer' onClick={() => getPdf(item)}>
                  <CommonToolTip placement={'top'} item={<img src={uploaded} />} showValue={'Download Pdf'} />
                </div>
              )}

              {/* {(item.status == 'draft' && !['doctor', 'ee', 'ee_manager'].includes(userData?.role)) && (
                <div
                  onClick={() => {
                    navigate(`/patient/${id}/questions/${item.id}/edit`);
                  }}
                  className='mb-2 ms-2 pointer'
                >
                  <CommonToolTip
                    placement={'top'}
                    item={<img src={editIconY} className='icon' style={{ cursor: 'pointer' }} />}
                    showValue={'Edit'}
                  />
                </div>
              )} */}

              {/* {item.status !== 'published' && (
                <CommonToolTip
                  placement={'top'}
                  item={
                    <div className='mb-2 ms-2 pointer'>
                      <div className='form-check form-switch toggleBtn pt-1'>
                        <input
                          className='form-check-input'
                          style={{ cursor: 'pointer' }}
                          checked={item.status == 'published'}
                          onChange={(e) => {
                            const windowConfirm = window.confirm(
                              `Are you sure,you want to ${
                                item.status == 'published' ? 'unpublish' : 'publish'
                              } conversion log?`
                            );
                            if (windowConfirm && item.status !== 'published') {
                              statusPublish(item);
                            }
                          }}
                          type='checkbox'
                          role='switch'
                        />
                      </div>
                    </div>
                  }
                  showValue={` ${item.status == 'published' ? 'Unpublish' : 'Publish'} `}
                />
              )} */}
            </>
          </div>
        </div>

        <div className='d-flex w-100 justify-content-between'>
          <div class='d-flex mt-1 mb-3'>
            <div class='me-2'>
              <img
                className='rounded coachImage float-start img-fluid'
                src={profileImage(item?.admin?.gender, item?.admin?.profile_url)}
              />
            </div>
            <div class=''>
              <h5 class='coachtext capitalize'>{item.admin ? item?.admin?.full_name : 'System'}</h5>
              <p class='zeefitness capitalize'>{teamRoles(item?.admin?.role)}</p>
            </div>
          </div>
        </div>
        <div>
          {item?.is_dead ? 
              <>
                <div>
                  <b>{item?.next_followup_date ? 'Next Followup Date :' : ''}</b>
                  &nbsp; No followup
                </div>
              </> : 
            <>
              {item?.next_followup_date ? 
                <div>
                  <b>{item?.next_followup_date ? 'Next Followup Date :' : ''}</b>
                  &nbsp;
                  {dateFormat(item?.next_followup_date)} · {timeFormat(item?.next_followup_date)}
                </div>
                :
                null
              }
            </>
          }
          
          {item?.pain_score ? 
            <div>
              <b>{item?.pain_score ? 'Pain Score :' : ''}</b>
              &nbsp;
              {item?.pain_score}
            </div>
            :
            null
          }
          {item?.conversion_probability ? 
            <div>
              <b>{item?.conversion_probability ? 'Conversion Probability :' : ''}</b>
              &nbsp;
              {item?.conversion_probability}
            </div>
            :
            null
          }
          {item?.conversion_type ? 
            <div>
              <b>{item?.conversion_type ? 'Conversion Type :' : ''}</b>
              &nbsp;
              {item?.conversion_type}
            </div>
            :
            null
          }
            
          <div>
            <b className='capitalize'> {item.title} </b>
          </div>
          <div>
            <b>{item?.behaviour_question_category?.title ? 'Category :' : ''}</b>
            &nbsp;
            {item?.behaviour_question_category?.title}
          </div>
          
          <div className='table-responsive'>
            <table className='w-100 table'>
              <thead>
                <tr>
                  <th width="10%">Sr.No.</th>
                  <th width="60%">Questions</th>
                  <th width="40%">Answers</th>
                  {/* <th>Attached Goal</th> */}
                </tr>
              </thead>
              {console.log(item.behaviour_questionnaire_answers)}
              <tbody>
                {item.behaviour_questionnaire_answers.map((value, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{value.behaviour_question.question}</td>
                      <td>{renderAnswer(value, 'answer')}</td>
                      {/* <td>{renderAnswer(item, 'recommendation')}</td> */}
                      {/* <td>{item?.patient_goal?.goal?.title}</td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <CommonAlert isShowAlert={isShowAlert} setIsShowAlert={setIsShowAlert} alertType={alertType} />
      <div className='d-flex justify-content-between align-items-center'>
        <div className='pt-3'>
          <button type='button' className='btn mt-3 btn-outline-primary' onClick={fetchCallRecordingAnalysis} disabled={callRecordingLoading}>
            {callRecordingLoading ? 'Loading...' : showCallRecordingModal ? 'Hide Call Recording Analysis' : 'Show Call Recording Analysis'}
          </button>
        </div>
        <div className='pt-3'>
          {
            !userData?.read_only && !['doctor', 'ee', 'ee_manager'].includes(userData?.role) && (
              <button type='button' className='btn mt-3 btn-outline-primary' onClick={newQuestions}>
                <img src={add} className='icon' /> Add Conversion Log
              </button>
            )
          }
          {
            !userData?.read_only && ['doctor'].includes(userData?.role) && userData?.department?.id == 2 && (
              <button type='button' className='btn mt-3 btn-outline-primary' onClick={newQuestions}>
                <img src={add} className='icon' /> Add Conversion Log
              </button>
            )
          }
        </div>
        <Loader show={isLoading} />
      </div>

      {showCallRecordingModal && (
        <div className='mt-3 mb-3'>
          <div className='table-responsive'>
            <table className='table table-bordered table-sm'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Customer Summary</th>
                  <th>Customer Intent</th>
                  <th>RM Name</th>
                  {/* <th>Created By</th> */}
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {callRecordingData.length > 0 ? (
                  callRecordingData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(callRecordingCurrentPage - 1) * callRecordingPageSize + index + 1}</td>
                      <td>{item.customer_summary || 'N/A'}</td>
                      <td>{item.customer_intent || 'N/A'}</td>
                      <td>{item.rm_name || 'N/A'}</td>
                      {/* <td>{item.admin_name || 'N/A'}</td> */}
                      <td>{item.created_at ? dateFormat(item.created_at) : 'N/A'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className='text-center'>
                      {callRecordingLoading ? 'Loading...' : 'No data found'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className='d-flex justify-content-end'>
            <div className='patientPagination mt-3'>
              <Pagination
                totalPages={callRecordingTotalPages}
                currentPage={callRecordingCurrentPage}
                setCurrentPage={setCallRecordingCurrentPage}
                length={callRecordingTotalCount}
              />
            </div>
          </div>
        </div>
      )}

      {behaviourQuetionData.map((item, index) => {
        return renderQuestionlist(item, index);
      })}
      <div className='d-flex justify-content-end'>
        <div className='patientPagination mt-3'>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </div>
  );
}

export default RenderQuestionTab;
